(function(){
	'use strict';

    if($('.accordion').length){

        $('.accordion .collapse.show').parent().addClass('active');

        $('.accordion .collapse').on('shown.bs.collapse', function () {
            $(this).parent().addClass('active');
        });

        $('.accordion .collapse').on('hidden.bs.collapse', function () {
            $(this).parent().removeClass('active');
        });
    }
}());